/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt není k dispozici`
};

const da_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Produktet er ikke tilgængeligt`
};

const de_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt nicht verfügbar`
};

const en_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Product unavailable`
};

const es_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Producto no disponible`
};

const fr_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Produit indisponible`
};

const hu_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Termék nem elérhető`
};

const it_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Prodotto non disponibile`
};

const nl_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Product niet beschikbaar`
};

const pl_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt niedostępny`
};

const pt_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Produto indisponível`
};

const sv_product_unavailable = /** @type {(inputs: {}) => string} */ () => {
	return `Produkten är inte tillgänglig`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const product_unavailable = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.product_unavailable(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("product_unavailable", locale)
	if (locale === "cs") return cs_product_unavailable(inputs)
	if (locale === "da") return da_product_unavailable(inputs)
	if (locale === "de") return de_product_unavailable(inputs)
	if (locale === "en") return en_product_unavailable(inputs)
	if (locale === "es") return es_product_unavailable(inputs)
	if (locale === "fr") return fr_product_unavailable(inputs)
	if (locale === "hu") return hu_product_unavailable(inputs)
	if (locale === "it") return it_product_unavailable(inputs)
	if (locale === "nl") return nl_product_unavailable(inputs)
	if (locale === "pl") return pl_product_unavailable(inputs)
	if (locale === "pt") return pt_product_unavailable(inputs)
	return sv_product_unavailable(inputs)
};